<template>
  <a-modal
    title="修改用户"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
        <!--:checkStrictly="true"-->
      <a-tree
        checkable
        :defaultExpandAll="true"
        v-model="checkedKeys"
        :treeData="treeData"
      />
    </a-spin>
    <template slot="footer" >

      <a-button key="cancel" @click="handleCancel">取消</a-button>
      <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
    </template>
  </a-modal>

</template>

<script>
import { fetchList, saveMenuList, fetchPerm } from '@api/sys/menu'
import { treeDataTranslate } from '@/utils/util'
export default {
  name: 'RolePermModal',
  data () {
    return {
      confirmLoading: false,
      visible: false,
      treeData: [],
      checkedKeys: [],
      autoExpandParent: true,
      selectedKeys: [],
      roleId: ''
    }
  },
  methods: {
    init (record) {
      this.visible = true
      this.confirmLoading = true
      this.roleId = record.roleId
      fetchPerm(record.roleId).then(res => {
        this.checkedKeys = res.data
      })
      fetchList().then(res => {
        this.treeData = treeDataTranslate(res.data, 'menuId', 'title')
        this.confirmLoading = false
      })
    },
    handleCancel () {
      this.visible = false
    },
    handleOk () {
      this.confirmLoading = true

      console.log(this.checkedKeys)

      saveMenuList(this.checkedKeys, this.roleId).then(res => {
        this.$message.success('保存成功')
        this.visible = false
      }).catch(err => {
        this.$message.error(err.msg)
      }).finally(_ => {
        this.confirmLoading = false
      })
    },
    onCheck (checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
    }
  }
}
</script>

<style scoped>

</style>
